import * as APITypes from "~/API";
import { getParcelList } from "~/services/server";
import { buildPropertyMap } from "../helpers";
import type { EntityListData, EntityListOptions } from "~/types";

export const formatParcelOptions = (
  parcelList: APITypes.Parcel[],
  propertyMap: Record<string, APITypes.Property>,
): EntityListOptions[] => {
  return parcelList.map((parcel) => {
    const property = parcel.propertyID
      ? propertyMap[parcel.propertyID]
      : undefined;
    return {
      value: parcel.id,
      text: `Parcel: ${parcel.name || parcel.id} - Property: ${
        property?.name || "Unknown"
      }`,
    };
  });
};

export const getParcelEntityList = async (
  ownerID: string,
  ownerType: APITypes.OwnerType,
): Promise<EntityListData> => {
  const parcelList = await getParcelList({ ownerID, ownerType });
  const propertyMap = await buildPropertyMap(ownerID, ownerType);

  return {
    propertyList: [],
    buildingList: [],
    unitList: [],
    serviceRequestList: [],
    amenityList: [],
    parcelList: parcelList.data,
    propertyMap,
    buildingMap: {},
    unitMap: {},
  };
};
